import React, { useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";

import CG_img from "../../Assets/uploads/full/cg_market_f.jpg";
import city_tour from "../../Assets/uploads/full/city_tour_f.jpg";
import corona_virus_ow from "../../Assets/uploads/full/corona_virus_ow.jpg";
import design_f from "../../Assets/uploads/full/design_f.jpg";
import inten_I from "../../Assets/uploads/full/inten_I.jpg";
import mobile_world_ow from "../../Assets/uploads/full/mobile_world_ow.jpg";
import online_exam_i from "../../Assets/uploads/full/online_exam_i.jpg";
import out_work_f from "../../Assets/uploads/full/out_work_f.jpg";
import student_registration_i from "../../Assets/uploads/full/student_registration_i.jpg";
import teacher_registration_I from "../../Assets/uploads/full/teacher_registration_I.jpg";
import throughput_I from "../../Assets/uploads/full/throughput_I.jpg";
import aiwrites from "../../Assets/uploads/full/aiwrites.png";
import allagents from "../../Assets/uploads/full/allagents.png";
import drSecondopinion from "../../Assets/uploads/full/dr-secondopinion.png";
import goatmassswabstesting from "../../Assets/uploads/full/goatmassswabstesting.png";
import infibitecards from "../../Assets/uploads/full/infibitecards.png";
import kitech from "../../Assets/uploads/full/kitech.png";
import MSIHMCT from "../../Assets/uploads/full/MSIHMCT.png";
import truemistri from "../../Assets/uploads/full/truemistri.png";
import vshowcard from "../../Assets/uploads/full/vshowcard.png";
import kisancloud from "../../Assets/uploads/full/kisancloud.png";
import website_ow from "../../Assets/uploads/full/website_ow.jpg";
import wiki_ow from "../../Assets/uploads/full/wiki_ow.jpg";

const projectDetails = [
  {
    imgPath: allagents,
    title: "allAgents",
    description: "",
    ghLink: "",
    demoLink: "",
  },
  {
    imgPath: vshowcard,
    title: "vShowcard",
    description: "",
    ghLink: "",
    demoLink: "",
  },
  {
    imgPath: kisancloud,
    title: "kisancloud",
    description: "",
    ghLink: "",
    demoLink: "",
  },
  {
    imgPath: MSIHMCT,
    title: "MSIHMCT",
    description: "",
    ghLink: "",
    demoLink: "",
  },

  {
    imgPath: goatmassswabstesting,
    title: "goatmassswabstesting",
    description: "",
    ghLink: "",
    demoLink: "",
  },
  {
    imgPath: drSecondopinion,
    title: "dr-Secondopinion",
    description: "",
    ghLink: "",
    demoLink: "",
  },
  {
    imgPath: infibitecards,
    title: "infibitecards",
    description: "",
    ghLink: "",
    demoLink: "",
  },
  {
    imgPath: aiwrites,
    title: "AI Writes",
    description: "",
    ghLink: "",
    demoLink: "",
  },
  {
    imgPath: throughput_I,
    title: "ThroughPut",
    description: "",
    ghLink: "",
    demoLink: "",
  },









  {
    imgPath: truemistri,
    title: "TrueMistri",
    description: "",
    ghLink: "",
    demoLink: "",
  },

  {
    imgPath: kitech,
    title: "KI Technologies",
    description: "",
    ghLink: "",
    demoLink: "",
  },






  {
    imgPath: out_work_f,
    title: "ACA Explorers",
    description: "",
    ghLink: "",
    demoLink: "",
  },


  {
    imgPath: website_ow,
    title: "Web Developer portfolio",
    description: "",
    ghLink: "",
    demoLink: "",
  },
  {
    imgPath: city_tour,
    title: "City Tour",
    description: "",
    ghLink: "",
    demoLink: "",
  },
  {
    imgPath: corona_virus_ow,
    title: "COVID 19",
    description: "",
    ghLink: "",
    demoLink: "",
  },
  {
    imgPath: mobile_world_ow,
    title: "Mobile World",
    description: "",
    ghLink: "",
    demoLink: "",
  },

  {
    imgPath: inten_I,
    title: "Shrigadi Foundation",
    description: "",
    ghLink: "",
    demoLink: "",
  },


  {
    imgPath: teacher_registration_I,
    title: "Teacher Registration",
    description: "",
    ghLink: "",
    demoLink: "",
  },

  {
    imgPath: student_registration_i,
    title: "Student Registration",
    description: "",
    ghLink: "",
    demoLink: "",
  },



  {
    imgPath: online_exam_i,
    title: "Online Exam",
    description: "",
    ghLink: "",
    demoLink: "",
  },


  {
    imgPath: design_f,
    title: "PSD to HTML",
    description: "",
    ghLink: "",
    demoLink: "",
  },
  {
    imgPath: CG_img,
    title: "CG Market",
    description: "",
    ghLink: "",
    demoLink: "",
  },

  {
    imgPath: wiki_ow,
    title: "Wikipedia",
    description: "",
    ghLink: "",
    demoLink: "",
  },
];

function Projects() {
  const [visibleCount, setVisibleCount] = useState(3);

  const handleLoadMore = () => {
    setVisibleCount((prevCount) => prevCount + 3);
  };

  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works</strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          {projectDetails.slice(0, visibleCount).map((project, index) => (
            <Col md={4} className="project-card" key={index}>
              <ProjectCard {...project} />
            </Col>
          ))}
        </Row>
        {visibleCount < projectDetails.length && (
          <Row style={{ justifyContent: "center" }} className="mb-5">
            <Col md={4} className="text-center">
              <Button onClick={handleLoadMore} className="mt-3 load-more-btn">
                Load More
              </Button>
            </Col>
          </Row>
        )}
      </Container>
    </Container>
  );
}

export default Projects;
